import React from 'react';
import { QuarterLoaderUniversal } from '@duxton-web/icons';
import { Table } from '@duxton-web/ui';
import { Typography } from 'antd';

import { ExperimentModel } from '../../../common/ExperimentModel';
import Service from '../../../lib/App';
import { Experiment, SuperExperiment } from '../../../lib/PlannerDTOs';
import SectionCollapse from '../../ExperimentFormV2/common/SectionCollapse';
import { convertUnixDayJS } from '../ExperimentDetailSubPage';
import {
  renderExperimentNameColumn,
  renderStatusColumn,
} from './DashboardColumn';

const { Text } = Typography;

interface OwnProps {
  experiment: Experiment;
}

type ExperimentOverlapProps = OwnProps;

interface ExperimentOverlapState {
  isLoading: boolean;
  experiments: ExperimentModel[];
  // eslint-disable-next-line @typescript-eslint/ban-types
  columns: {}[];
  data: string[];
}

export class ExperimentOverlap extends React.Component<
  ExperimentOverlapProps,
  ExperimentOverlapState
> {
  state = {
    isLoading: true,
    experiments: undefined,
    columns: undefined,
    data: undefined,
  };

  componentDidMount() {
    const experiment = this.props.experiment;

    //populate columns
    this.getColumns();

    // api call to fetch overlaps and populate table
    this.loadOverlapExps(experiment.name).then(() => {
      this.populateData(this.state.experiments);
    });
  }

  render() {
    if (!this.state.experiments?.length) {
      return (
        <div style={{ padding: '0 32px' }}>
          <SectionCollapse defaultOpen title="Overlapping Experiments">
            <Text>There are no overlaps with this experiment.</Text>
          </SectionCollapse>
        </div>
      );
    }

    const data = this.state.data;
    const columns = this.state.columns;
    return (
      <div style={{ marginBottom: '16px', padding: '0 32px' }}>
        {this.state.isLoading && (
          <QuarterLoaderUniversal style={{ marginLeft: '50%' }} />
        )}
        {data != null && data.length > 0 && (
          <SectionCollapse defaultOpen title="Overlapping Experiments">
            <Table
              columns={columns}
              dataSource={data}
              pagination={false}
              loading={this.state.isLoading}
            />
          </SectionCollapse>
        )}
      </div>
    );
  }
  private loadOverlapExps = async (name: string): Promise<void> => {
    this.setState({ isLoading: true });
    try {
      const r: Experiment[] =
        await Service.planner.fetchOverlappingExperiments(name);
      const experiments: ExperimentModel[] = r.map(
        (e: Experiment): ExperimentModel => new ExperimentModel(e),
      );
      this.setState({
        experiments: experiments,
        isLoading: false,
      });
    } catch (e) {
      const experiments = [];
      this.setState({
        isLoading: false,
        experiments: experiments,
      });
    }
  };

  private getColumns() {
    let columns = [
      {
        title: 'Experiment Name',
        dataIndex: 'name',
        key: 'name',
      },
      {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
      },
      {
        title: 'Start Date',
        dataIndex: 'start',
        key: 'start',
      },
      {
        title: 'End Date',
        dataIndex: 'end',
        key: 'end',
      },
    ];
    this.setState({
      columns: columns,
    });
  }
  private populateData(exps: ExperimentModel[]) {
    let rows = [];
    if (!exps || exps.length == 0) {
      return;
    }
    const expsV2 = exps.map((exp) => {
      return exp.experiment as SuperExperiment;
    });

    expsV2.forEach((exp) => {
      const [startDate, endDate] = exp.constraints.filter(
        (constraint) => constraint.target === 'ts',
      );

      rows.push({
        key: exp,
        name: renderExperimentNameColumn(exp.name, exp),
        status: renderStatusColumn(exp.state),
        start: convertUnixDayJS(startDate?.value),
        end: convertUnixDayJS(endDate?.value),
      });
    });

    this.setState({
      data: rows,
    });
  }
}

export default ExperimentOverlap;
